import { combineReducers } from 'redux-immutable'
import { applyMiddleware, compose, createStore } from 'redux'
import thunk from 'redux-thunk'
import connectivityReducer from './scenes/services/reducer'
import { rootReducer as engagementReducer } from './scenes/EngagementPlatform/services/reducer'
import { rootReducer as schedulingReducer } from './scenes/GroupScheduling/scenes/Scheduling/services/reducer'
import { rootReducer as hackersmindReducer } from './scenes/HackerMind/services/reducer'

import environment from './environment'

import darkly from './scenes/EngagementPlatform/services/darkly'

const rootReducer = combineReducers({
  engagement: engagementReducer,
  scheduling: schedulingReducer,
  connectivity: connectivityReducer,
  hackermind: hackersmindReducer
})

const composeEnhancers =
  typeof window === 'object' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({})
    : compose

const enhancer = composeEnhancers(
  applyMiddleware(thunk)
  // other store enhancers if any
)

const store = createStore(rootReducer, enhancer)

darkly.init({
  clientSideId: environment['DARKLY'],
  dispatch: store.dispatch,
  options: {
    sendEvents: false
  }
})

export default store
